<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <!-- Search -->
          <b-col>
            <div style="display: flex; flex-direction: row; width: 100%; align-items: center;">
              <b-form-input
                v-model="searchQuery"
                style="width: 30%;"
                :placeholder="$t('areas_management.place_holders.search')"
              />
              <b-button
                v-if="user.role === 'admin' || this.$store.state.app.appConfig.type === 'ow-admin'"
                variant="primary"
                style="margin-left: 20px;"
                :disabled="isAreaLimitExceeded"
                @click="openCreateLocationModal()"
              >
                <span class="text-nowrap">
                  {{ $t('areas_management.buttons.add') }}
                </span>
              </b-button>
              <span v-if="isAreaLimitExceeded" style="color: red; margin-left: 20px;">Olet luonut maksimimäärän alueita, pyydä järjestelmävalvojaa päivittämään tilaus!</span>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refAreaListTable"
        class="position-relative"
        :items="fetchAreas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="$t('areas_management.no_match_record_found')"
      >
        <template #cell(area)="data">.
          <b-media vertical-align="center">
            <b-link
              :to="{ name: 'apps-personels-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
              style="text-transform: capitalize"
            >
              {{ data.item.fullName }}
            </b-link>
          </b-media>
        </template>

        <!-- Column Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.hwUiLayout.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-b-modal.create-areas-modal
              @click="editArea(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">
                {{ $t('areas_management.buttons.edit') }}
              </span>
            </b-dropdown-item>

            <b-dropdown-item
              v-b-modal.modal-danger
              @click="onDeleteArea(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">
                {{ $t('areas_management.buttons.delete') }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>
    <areas-list-add-new
      :edit-area="editedArea"
      @modal-open="onModalOpen"
      @modal-close="onModalClose"
      @create-area="onAreaCreateEdit"
    />
    <b-modal
      id="modal-danger"
      ok-only
      ok-variant="danger"
      ok-title="Delete"
      modal-class="modal-danger"
      centered
      :title="$t('areas_management.titles.delete_area')"
      @ok="confirmDelete"
    >
      <b-card-text>
        {{ $t('areas_management.form_items.confirm_delete_content') }}
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BLink, VBModal, BButton, BDropdown, BDropdownItem,
  BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useAreaList from './useAreaList'
import AreasListAddNew from './AreasListAddNew.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BTable,
    BMedia,
    BLink,
    BButton,
    AreasListAddNew,
    BCardText,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      editedArea: null,
      isAreaLimitExceeded: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.appAuth.authUser || {}
    },
    selectedAccount() {
      return this.$store.state.appAccount.selectedAccount || {}
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
  methods: {
    onLoadMore() {
      this.currentPage += 1
      this.loadMore = true
    },
    async checkIsAreaLimitExceeded() {
      const areas = await this.fetchAccountAreas()
      // eslint-disable-next-line no-nested-ternary
      this.isAreaLimitExceeded = this.selectedAccount.value.subscription.areaLevel === 3
        ? areas.length === 99
        // eslint-disable-next-line no-nested-ternary
        : this.selectedAccount.value.subscription.areaLevel === 2
          ? areas.length === 19
          : this.selectedAccount.value.subscription.areaLevel === 1
            ? areas.length === 9
            : areas.length === 4
    },
    async openCreateLocationModal() {
      if (this.appConfig.type === 'ow-admin') {
        await this.checkIsAreaLimitExceeded()
      }
      if (!this.isAreaLimitExceeded) {
        this.$bvModal.show('create-areas-modal')
      }
    },
    editArea(area) {
      this.editedArea = {
        id: area.id,
        name: area.name,
        emails: area.emails,
        confirmation_emails: area.confirmation_emails,
        contract: area.contract,
        location: {
          address: {
            city: area.city,
            postcode: area.postcode,
            state: area.state,
            streetAddress: area.streetAddress,
          },
          contact: area.location.contact,
          abscenceInfo: area.location.abscenceInfo,
          gps: {
            lat: area.location.gps.lat,
            lon: area.location.gps.lon,
          },
          locationDetails: area.location.locationDetails,
        },
        category: area.category,
        requirements: area.requirements,
      }
    },
  },
  setup() {

    function onModalClose() {
      this.editedArea = null
    }

    const {
      refAreaListTable,
      searchQuery,
      tableColumns,
      onModalOpen,
      onAreaCreateEdit,
      onDeleteArea,
      confirmDelete,
      fetchAreas,
      fetchAccountAreas,
    } = useAreaList()

    return {
      refAreaListTable,
      searchQuery,
      tableColumns,
      onModalOpen,
      onAreaCreateEdit,
      onModalClose,
      onDeleteArea,
      confirmDelete,
      fetchAreas,
      fetchAccountAreas,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-select.scss';
</style>
